<template>
    <div class="login-wrap">
        <div class="login-header">
            <div class="logo-circle">
                <van-icon name="shop-o" size="40" color="#fff" />
            </div>
        </div>

        <div class="login-card">
            <van-field
                v-model="phone"
                type="text"
                label="账号"
                left-icon="user-o"
                placeholder="请输入账号"
                clearable
                :rules="[{ required: true }]"
            />
            <van-field
                v-model="password"
                type="password"
                label="密码"
                left-icon="shield-o"
                placeholder="请输入密码"
                clearable
                style="margin-top: 1px;"
            />

            <div style="padding: 24px 16px 8px;">
                <van-button
                    @click="login"
                    :loading="isLoading"
                    loading-text="登录中..."
                    type="primary"
                    round
                    block
                    color="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                >
                    登 录
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from 'vant';
import { loginReq } from '@/request.js';

export default {
    setup() {
        const router = useRouter();
        const phone = ref('');
        const password = ref('');
        const isLoading = ref(false);

        const login = () => {
            if (phone.value === '') {
                Toast({ message: '账号不能为空', position: 'bottom' });
                return;
            }
            if (password.value === '') {
                Toast({ message: '密码不能为空', position: 'bottom' });
                return;
            }
            isLoading.value = true;
            loginReq({ phone: phone.value, password: password.value }, (res) => {
                isLoading.value = false;
                if (res.IsSuccess) {
                    localStorage.setItem("token", res.Message);
                    router.push({ path: '/index' });
                } else {
                    Toast({ message: res.Message, position: 'bottom' });
                }
            });
        };

        return { phone, password, isLoading, login };
    }
}
</script>

<style scoped>
.login-wrap {
    min-height: 100vh;
    background: linear-gradient(160deg, #667eea 0%, #764ba2 60%, #f5f5f5 60%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 0 40px;
}

.logo-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.app-title {
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 8px;
    margin: 0 0 6px;
}

.app-subtitle {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
    letter-spacing: 2px;
}

.login-card {
    width: 88%;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.18);
    overflow: hidden;
    margin-top: 8px;
}
</style>
